@import 'styles/variables';
@import 'styles/mixins.scss';

.logoAndCompanyName {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
